import { render, staticRenderFns } from "./BaseVideoPackshotTimeline.vue?vue&type=template&id=08333781&scoped=true&"
import script from "./BaseVideoPackshotTimeline.vue?vue&type=script&lang=ts&"
export * from "./BaseVideoPackshotTimeline.vue?vue&type=script&lang=ts&"
import style0 from "./BaseVideoPackshotTimeline.vue?vue&type=style&index=0&id=08333781&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08333781",
  null
  
)

export default component.exports